import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import dayjs from "dayjs";

import packageData from "../../../../package.json";
import {getMainAppHost, URLS} from "@/shared/utils/url/url";
import { isProduction } from "@/shared/utils/assembly";

/**
 * Debug, show last build time
 */
const VersionView = ({ link, info }) => {
  let versionValue = `Version: ${packageData.version}`;

  if (info && info.lastCommitTime) {
    const dateVal = dayjs(info.lastCommitTime);
    const formatDate = isProduction() ? "DD.MM.YYYY" : "DD.MM.YYYY HH:MM";
    versionValue += ` - ${dateVal.format(formatDate)}`;
  }

  if (link && !isProduction()) {
    return (
      <span>
        <Link href={getMainAppHost() + URLS.patchNotes}>
          {versionValue}
        </Link>
      </span>
    );
  }
  return <span>{versionValue}</span>;
};

VersionView.propTypes = {
  link: PropTypes.bool,
  info: PropTypes.any,
};

export async function getServerSideProps() {
  let data = null;

  try {
    const res = await fetch("info.json");
    data = await res.json();
  } catch (error) {
    console.log(`VersionView: ${error}`);
  }

  return {
    props: {
      info: data,
    },
  };
}

export default VersionView;
